$(document).ready(function () {
	$('.resources-search input').on('input', (e) => {
		if (e.target.value.length >= 3 || e.target.value.length === 0) {
			updateBannerStatus();
		}
	});
	$('.resources-filter input').on('change', () => {
		updateBannerStatus();
	});

	$(document).on('jet-filter-content-rendered', () => {
		updateBannerStatus(true);
	});

	$('body').on("click", ".jet-filters-pagination__item",function() {
		var blogHeight = $('.topScrollResources').offset();
		var scrollto = blogHeight.top - 100;
		$('html, body').animate({scrollTop:scrollto}, 100);
	});

	$('.resources-filter .jet-checkboxes-list__row ').each(function (i,e){
		let label = $(this).find('.jet-checkboxes-list__input').attr('data-label').toLowerCase();
		$(this).attr('data-hash', label.replaceAll(' & ', '_').replaceAll(' ', '_'))
	})

	if(getQueryVariable('cat')){
		setTimeout(()=>{
			$('.resources-filter').find('.jet-checkboxes-list__row[data-hash="'+getQueryVariable('cat')+'"] label').click();
		}, 1000)
	}else{
		$('.topScrollResources').addClass('active');
	}

});

function updateBannerStatus(bool = false) {
	if(bool){
		$('.topScrollResources').addClass('active');
	}
	const page = $('#recourcesAll .jet-listing-grid__items').data('page');
	let hasAnythingInSearch = false;
	let hasAnyCheckboxesSelected = false;

	hasAnythingInSearch = !!$('.resources-search input').val();

	$('.resources-filter input').each(function () {
		if (this.checked) {
			hasAnyCheckboxesSelected = true;
		}
	});

	if (!hasAnythingInSearch && !hasAnyCheckboxesSelected && page <= 1) {
		$('#recourcesAll123').show();
	} else {
		$('#recourcesAll123').hide();
	}
}

function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		if (decodeURIComponent(pair[0]) == variable) {
			return decodeURIComponent(pair[1]);
		}
	}
}

String.prototype.replaceAll = function(str1, str2, ignore)
{
	return this.replace(new RegExp(str1.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g,"\\$&"),(ignore?"gi":"g")),(typeof(str2)=="string")?str2.replace(/\$/g,"$$$$"):str2);
}
